"use client";

import { Check } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WaaromKiezenVoorEkonorm() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const benefits = [{
    title: "Snelle en professionele service",
    description: "Wij bieden een vlotte afhandeling van uw aanvraag met minimale wachttijden en maximale efficiëntie."
  }, {
    title: "Vaste contactpersoon",
    description: "U krijgt één deskundige contactpersoon toegewezen die u van A tot Z begeleidt tijdens het hele proces."
  }, {
    title: "Duidelijke prijsstructuur",
    description: "Geen verborgen kosten of verrassingen achteraf. Alles wordt vooraf helder gecommuniceerd."
  }, {
    title: "Klantgerichte aanpak",
    description: "Uw tevredenheid staat bij ons voorop. Wij luisteren naar uw wensen en bieden op maat gemaakte oplossingen."
  }, {
    title: "Flexibele planning",
    description: "Wij passen ons aan uw schema aan en zorgen voor een keuring op een moment dat u uitkomt. Meerdere keuringen worden op hetzelfde moment ingepland."
  }];
  return <section ref={sectionRef} className="bg-light-background py-16 md:py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div className={`space-y-8 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <h2 className="text-3xl md:text-4xl font-bold text-text-dark leading-tight">
              Waarom Kiezen Voor Ekonorm
            </h2>

            <ul className="space-y-6">
              {benefits.map((benefit, i) => <li key={i} data-index={i} className={`flex items-start gap-4 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
              transitionDelay: sectionVisible ? `${(i + 1) * 100}ms` : "0ms"
            }}>
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-primary flex items-center justify-center mt-0.5 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-110">
                    <Check className="w-4 h-4 text-foreground-primary" strokeWidth={3} />
                  </div>
                  <div className="flex-1">
                    <p className="font-semibold text-lg text-text-dark mb-1">
                      {benefit.title}
                    </p>
                    <p className="text-base text-text-dark/80 leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </li>)}
            </ul>
          </div>

          {}
          <div className={`flex items-center justify-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: sectionVisible ? "200ms" : "0ms"
        }}>
            <div className="w-full max-w-md lg:max-w-lg">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1511866/img/ekonorm_company_logo_large.png" alt="Ekonorm Logo" className="w-full h-auto object-contain" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}